var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCccoil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "cccoil-grad"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(206, 75%, 49%)",
    stopOpacity: 1,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "hsl(331, 90%, 56%)",
    stopOpacity: 1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#cccoil-grad)",
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 363,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "1939 2281",
    transform: "rotate(360, 400, 400)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    r: 346.5,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "1762 2177",
    transform: "rotate(343, 400, 400)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    r: 330,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "1595 2073",
    transform: "rotate(326, 400, 400)",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    r: 313.5,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "1435 1970",
    transform: "rotate(309, 400, 400)",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    r: 297,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "1284 1866",
    transform: "rotate(291, 400, 400)",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    r: 280.5,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "1141 1762",
    transform: "rotate(274, 400, 400)",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    r: 264,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "1007 1659",
    transform: "rotate(257, 400, 400)",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    r: 247.5,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "881 1555",
    transform: "rotate(240, 400, 400)",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    r: 231,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "764 1451",
    transform: "rotate(223, 400, 400)",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    r: 214.5,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "655 1348",
    transform: "rotate(206, 400, 400)",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    r: 198,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "554 1244",
    transform: "rotate(189, 400, 400)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    r: 181.5,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "462 1140",
    transform: "rotate(171, 400, 400)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    r: 165,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "378 1037",
    transform: "rotate(154, 400, 400)",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    r: 148.5,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "302 933",
    transform: "rotate(137, 400, 400)",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    r: 132,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "235 829",
    transform: "rotate(120, 400, 400)",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    r: 115.5,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "176 726",
    transform: "rotate(103, 400, 400)",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    r: 99,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "126 622",
    transform: "rotate(86, 400, 400)",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    r: 82.5,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "84 518",
    transform: "rotate(69, 400, 400)",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    r: 66,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "50 415",
    transform: "rotate(51, 400, 400)",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    r: 49.5,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "25 311",
    transform: "rotate(34, 400, 400)",
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    r: 33,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "8 207",
    transform: "rotate(17, 400, 400)",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    r: 16.5,
    cx: 400,
    cy: 400,
    strokeWidth: 7,
    strokeDasharray: "0 104",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCccoil);
export default __webpack_public_path__ + "static/media/cccoil.55d39d0319567d9d19fe2af526cb1c48.svg";
export { ForwardRef as ReactComponent };